// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 974) return "static/chunks/974-3f7e67ef7447ae54.js";
	if (chunkId === 209) return "static/chunks/209-858a74c8e444867d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"329d19345f399f6a","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"5d3ff297d26fb88c","367":"12a363a7b0f4fc09","639":"cf9d73bb0d566e4a","748":"5f89c74b8236bb27"}[chunkId] + ".js";
};